export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-deviant-art-76f8b090c714557c8793e4a043e76e0f.svg";